export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const API_ENDPOINT_SUPPORT = process.env.REACT_APP_API_ENDPOINT_SUPPORT;
